module.exports = __webpack_public_path__ + "static/media/12. B19. Superficie sólida. 32 x 62 x 20  cm. 2020 copy.ddef478b.png";